<template>
  <el-form ref="form" :model="curInput.key" :rules="rules" label-width="100px">
    <el-form-item label="表单选择" prop="select_status">
      <el-radio-group v-model="curInput.key.select_status">
        <el-radio :label="0">本表</el-radio>
        <el-radio :label="1">其他表单</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="所选表单" prop="form_model" v-show="curInput.key.select_status == 1">
      <el-select v-model="curInput.key.form_model" placeholder="请选择表单" class="h-40 w-200">
        <el-option v-for="(item, index) in formList" :label="item.title + '(' + item.name + ')'" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="选项标题配置" prop="title_config">
      <el-input v-model.trim="curInput.key.title_config" class="h-40 w-300" placeholder="请选择内容显示名称"></el-input>
     <div class="form-tips">填写规范遵循PHP语法,如：$姓名字段名."(".$手机字段名.")".如果直接用某字段名，则填$字段名即可</div>
    </el-form-item>
    <el-form-item label="选项标题配置参考值">
      <el-select v-model="title_reference" multiple placeholder="对选项标题配置参数值" class="w-300">
        <el-option v-for="item in fieldList" :label="item.title + '(' + item.name + ')'" :value="item.name"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="是否级联方式选择" prop="is_link">
      <el-radio-group v-model="curInput.key.is_link">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="是否可选无" prop="has_null">
      <el-radio-group v-model="curInput.key.has_null">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="级联关联字段选择" prop="link_pid" v-show="curInput.key.is_link == 1">
      <el-select v-model="curInput.key.link_pid" placeholder="级联关联字段选择">
        <el-option v-for="item in fieldList" :label="item.title + '(' + item.name + ')'" :value="item.name"></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item label="表单显示名称" prop="form_name">
      <el-select v-model="curInput.key.form_name" multiple placeholder="请选择表单显示名称">
        <el-option v-for="item in fieldList" :label="item.title" :value="item.name"></el-option>
      </el-select>
    </el-form-item> -->
    <el-form-item label="筛选条件" prop="filter">
      <el-input v-model.trim="curInput.key.filter" class="h-40 w-300"></el-input>
      <div class="form-tips">支持等于==，不等于<>，大于>，小于<逻辑判断</div>
    </el-form-item>
    <el-form-item label="是否有搜索功能" prop="has_search">
      <el-radio-group v-model="curInput.key.has_search">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="类型" prop="type">
      <el-radio-group v-model="curInput.key.type">
        <el-radio :label="10">下拉选择</el-radio>
        <el-radio :label="20">模糊匹配</el-radio>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>
<script>
  import http from '../../../assets/js/http'
  export default {
    props: ['curInput', 'inputList'],
    data() {
      return {
        rules: {
          form_model: [
            { required: true, message: '请选择表单' }
          ],
          title_config: [
            { required: true, message: '请选择内容显示名称' }
          ],
          form_name: [
            { required: true, message: '请选择编辑显示名称' }
          ]
        },
        formList: [],
        fieldList: [],
        hasGetForm: false,
        inputChange: false,
        title_reference: []
      }
    },
    created() {
      if (this.curInput.key.select_status == 1) {
        this.getFormList()
      } else if (this.curInput.key.select_status == 0) {
        this.getFieldFromInputList()
      }
      if (this.curInput.key.form_model) {
        this.getFormField()
      }
    },
    mixins: [http],
    methods: {
      getFormList() {
        let postData = {
          params: {
            status: 1
          }
        }
        this.apiGet('form/models', postData).then((res) => {
          if (res.code == 200) {
            this.formList = res.data.list
            this.hasGetForm = true
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getFormField() {
        let postData = {
          params: {
            type: 1
          }
        }
        let id = this.curInput.key.form_model
        // 获取缓存字段
        if (Lockr.get('fields') && Lockr.get('fields')[id]) {
          this.fieldList = Lockr.get('fields')[id]
          return
        }
        if (id) {
          this.apiGet(`form/models/${id}/fields`, postData).then((res) => {
            if (res.code == 200) {
              this.fieldList = res.data
              // 缓存表单字段列表
              let fields = Lockr.get('fields') || {}
              fields[id] = res.data
              Lockr.set('fields', fields)
            } else {
              _g.dealError(this, res)
            }
          })
        }
      },
      getFieldFromInputList() {
        this.fieldList = []
        _(this.inputList).forEach((res) => {
          let temp = {
            name: res.default.name,
            title: res.default.title
          }
          this.fieldList.push(temp)
        })
      },
      formChange() {
        this.getFormField()
      },
      resetShowName() {
        this.curInput.key.show_name = ''
      },
      setInputChange(value) {
        this.inputChange = value
      }
    },
    watch: {
      'curInput'() {
        this.setInputChange(true)
      },
      'curInput.key.form_model'() {
        this.formChange()
        if (this.inputChange) {
          return
        }
        this.resetShowName()
      },
      'curInput.key.is_link'() {
        if (this.inputChange) {
          return
        }
        this.curInput.key.link_pid = null
      },
      'curInput.key.select_status'() {
        // 是否选择表单状态改变
        if (this.curInput.key.select_status == 1 && !this.hasGetForm) {
          this.getFormList()
        } else if (this.curInput.key.select_status == 0) {
          this.getFieldFromInputList()
        }
        if (this.inputChange) {
          return
        }
        this.curInput.key.form_model = ''
        this.resetShowName()
      },
      'inputList'() {
        if (this.curInput.key.select_status == 0) {
          this.getFieldFromInputList()
        }
      },
      'inputChange'() {
        if (this.inputChange) {
          this.setInputChange(false)
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      // 离开前删除字段缓存
      Lockr.rm('fields')
      next()
    }
  }
</script>



// WEBPACK FOOTER //
// foreignkeyConfig.vue?70accac9